import { makeRequest } from "../http-common";

const MessageDataService = {
  async getAll() {
    return makeRequest("get", "/message/list");
  },

  async getAllUnread() {
    return makeRequest("get", "/message/unread");
  },
  
  async getById(id) {
    return makeRequest("get", `/message/${id}`);
  },

  async update(id, data){
    return makeRequest("put", `/message/${id}`, data);
  },

  async create(data) {
    return makeRequest("post", `/message/`, data)
  },

  async delete(id) {
    return makeRequest("delete", `/message/${id}`);
  },

  async read(id) {
    return makeRequest("put", `/message/${id}/read`);
  }

};

export default MessageDataService;